"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customStyles = exports.NoOptionsMessage = exports.MultiValueLabel = exports.LoadingIndicator = exports.DropdownIndicator = exports.ClearIndicator = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _reactSelect = require("react-select");
var _FormElements = require("../../../styles/FormElements");
var _select = require("../select.style");
var _ = require("../../");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const LoadingIndicator = _ref => {
  let {
    fit = 'medium',
    disabled = false
  } = _ref;
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !disabled && (0, _jsxRuntime.jsx)(_select.Components.LoadingIndicator, (0, _extends2["default"])({
      fit: fit
    }, {
      children: (0, _jsxRuntime.jsxs)("svg", (0, _extends2["default"])({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100"
      }, {
        children: [(0, _jsxRuntime.jsx)("circle", {
          className: "track",
          cx: "50",
          cy: "50",
          fill: "none",
          r: "40"
        }), (0, _jsxRuntime.jsx)("circle", {
          className: "spinner",
          cx: "50",
          cy: "50",
          fill: "none",
          r: "40",
          strokeDasharray: "55 200"
        })]
      }))
    }))
  });
};
exports.LoadingIndicator = LoadingIndicator;
const DropdownIndicator = _a => {
  var {
      fit = 'medium'
    } = _a,
    props = __rest(_a, ["fit"]);
  return (0, _jsxRuntime.jsx)(_reactSelect.components.DropdownIndicator, (0, _extends2["default"])({}, props, {
    children: (0, _jsxRuntime.jsx)(_.Icon, {
      name: props.selectProps.menuIsOpen ? 'chevron-up' : 'chevron-down',
      size: fit === 'large' ? '24' : '20'
    })
  }));
};
exports.DropdownIndicator = DropdownIndicator;
const ClearIndicator = _a => {
  var {
      fit = 'medium',
      disabled = false
    } = _a,
    props = __rest(_a, ["fit", "disabled"]);
  const {
      children = (0, _jsxRuntime.jsx)(_FormElements.ClearIconButton, {
        icon: "times-circle",
        variant: "plain",
        ariacurrent: "false",
        fit: fit,
        disabled: disabled
      })
    } = props,
    _b = props.innerProps,
    {
      ref
    } = _b,
    restInnerProps = __rest(_b, ["ref"]);
  return (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({}, restInnerProps, {
    ref: ref
  }, {
    children: (0, _jsxRuntime.jsx)("div", (0, _extends2["default"])({
      style: {
        padding: '0px 5px'
      }
    }, {
      children: children
    }))
  }));
};
exports.ClearIndicator = ClearIndicator;
const MultiValueLabel = props => {
  return (0, _jsxRuntime.jsx)(_reactSelect.components.MultiValueLabel, (0, _extends2["default"])({}, props, {
    children: props.data[props.renderValue]
  }));
};
exports.MultiValueLabel = MultiValueLabel;
const customStyles = exports.customStyles = {
  multiValue: provided => _select.Components.CustomStyles.MultiValue(provided),
  multiValueRemove: provided => _select.Components.CustomStyles.MultiValueRemove(provided),
  menu: provided => _select.Components.CustomStyles.Menu(provided)
};
const NoOptionsMessage = _a => {
  var {
      customNoOptionsMessage
    } = _a,
    props = __rest(_a, ["customNoOptionsMessage"]);
  return customNoOptionsMessage ? (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: customNoOptionsMessage
  }) : (0, _jsxRuntime.jsx)(_reactSelect.components.NoOptionsMessage, (0, _extends2["default"])({}, props));
};
exports.NoOptionsMessage = NoOptionsMessage;